let swipe;

class MisclaireSwipe {
  root;
  currentActiveIndex = 0;
  initialX = 0;
  initialY = 0;

  parent;

  constructor({ root }) {
    this.root = root;

    const element = document.getElementById("misclaire-product-images-mobile");

    if (element) {
      this.parent = element;

      element.addEventListener("touchstart", this.onTouchStart.bind(this));
      element.addEventListener("touchend", this.onTouchEnd.bind(this));
    }
  }

  onTouchStart(event) {
    this.initialX = event.changedTouches[0].pageX;
    this.initialY = event.changedTouches[0].pageY;
  }

  onTouchEnd(event) {
    if (
      event.target.classList.contains("chevron-left-icon") ||
      event.target.classList.contains("left-arrow") ||
      event.target.classList.contains("msclaire-prev-button")
    ) {
      this.onSwipePrev();
      return;
    }

    if (
      event.target.classList.contains("chevron-right-icon") ||
      event.target.classList.contains("right-arrow") ||
      event.target.classList.contains("msclaire-next-button")
    ) {
      this.onSwipeNext();
      return;
    }

    // Swipe right, prev
    if (
      event.changedTouches[0].pageX !== this.initialX &&
      event.changedTouches[0].pageX - this.initialX > 100
    ) {
      this.onSwipePrev();
    }

    // Swipe left, next
    if (
      event.changedTouches[0].pageX !== this.initialX &&
      event.changedTouches[0].pageX - this.initialX < 100
    ) {
      this.onSwipeNext();
    }
  }

  onSwipePrev = () => {
    // Swipe right, prev
    const children = document.querySelectorAll(
      "#misclaire-product-images-mobile div.items"
    );

    if (!children || children.length === 0) {
      return;
    }

    if (this.currentActiveIndex > 0) {
      children.forEach((item, index) => {
        item.classList.remove("active");

        if (
          index === this.currentActiveIndex - 1 &&
          this.currentActiveIndex > 0
        ) {
          item.classList.add("active");

          this.parent.style.height = `${item.clientHeight}px`;
        }
      });

      this.currentActiveIndex -= 1;
    }
  };

  onSwipeNext = () => {
    // Swipe left, next
    const children = document.querySelectorAll(
      "#misclaire-product-images-mobile div.items"
    );

    if (!children || children.length === 0) {
      return;
    }

    if (this.currentActiveIndex !== children.length - 1) {
      children.forEach((item, index) => {
        item.classList.remove("active");

        if (index === this.currentActiveIndex + 1) {
          item.classList.add("active");

          this.parent.style.height = `${item.clientHeight}px`;
        }
      });

      this.currentActiveIndex += 1;
    }
  };
}

document.addEventListener("DOMContentLoaded", function () {
  function selectVariantID() {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.has("variantId")) {
      const variantId = urlSearchParams.get("variantId");
      var selectElement = document.querySelector("select.t4s-product__select.t4s-d-none");
      var selectOptionsElement = document.querySelectorAll(
        "select.t4s-product__select.t4s-d-none option"
      );

      for (let index = 0; index < selectOptionsElement.length; index++) {
        const element = selectOptionsElement[index];

        if (element.value === variantId) {
          element.selected = true;
          selectElement.value = variantId;
        } else {
          element.selected = false;
        }
      }
    }
  }

  function selectColorVariant() {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.has("color")) {
      const color = urlSearchParams.get("color");
      const list = document.querySelectorAll('div[data-opname="color"] ul li');

      for (let index = 0; index < list.length; index++) {
        const element = list[index];

        if (
          element.dataset["value"].toLowerCase() ===
          color.toLowerCase().replace(" ", "-")
        ) {
          element.classList.add("is-selected");
        } else {
          if (element.classList.contains("is-selected-nt")) {
            element.classList.remove("is-selected-nt");
          }

          if (element.classList.contains("is-selected")) {
            element.classList.remove("is-selected");
          }
        }
      }

      if (color) {
        updateImageList(color);
      }
    }
  }

  function updateImageList(selectedColor) {
    const element = document.getElementById("misclaire-product-images");
    const mobileElement = document.getElementById(
      "misclaire-product-images-mobile"
    );

    const dataImages = element.dataset["images"]
      .split(",")
      .map((item) => {
        const img = item.replace(/(\t)*/, "").split("|");

        if (img.length) {
          return {
            name: img[0],
            url: `//misclaire.myshopify.com/cdn/shop/${img[1]}`,
          };
        }
      })
      .filter((item) => item.name.length > 0);

    let list = `<button class="msclaire-button msclaire-prev-button">
    <svg class="chevron-left-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="left-arrow"></path></svg></button>
  <button class="msclaire-button msclaire-next-button">
    <svg class="chevron-right-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="right-arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>`;

    const regex = new RegExp(
      selectedColor.replace(/\s/g, "-").toLowerCase(),
      "i"
    );
    const sharedPatternRegex = new RegExp(/(all)|(share)/, "i");

    let itemIdx = 0;

    dataImages.forEach((item, index) => {
      if (regex.test(item.name)) {
        const active = itemIdx === 0 ? "active" : "";

        list += `<div class="scalingworks items img-idx-${index} ${active}"><img src="${item.url}" style="height: auto; width: 100%; object-fit: cover;" /></div>`;

        itemIdx++;
      }
    });

    // Add shared image at the end
    dataImages.forEach((item, index) => {
      if (sharedPatternRegex.test(item.name)) {
        const active = itemIdx === 0 ? "active" : "";

        list += `<div class="scalingworks items img-idx-${index} ${active}"><img src="${item.url}" style="width: 100%; object-fit: cover;" /></div>`;

        itemIdx++;
      }
    });

    element.innerHTML = list;
    mobileElement.innerHTML = list;

    setTimeout(() => {
      // Set the default height to image container
      const mobileContainer = document.getElementById(
        "misclaire-product-images-mobile"
      );

      const children = document.querySelectorAll(
        "#misclaire-product-images-mobile div.items"
      );

      if (!children || children.length === 0) {
        return;
      }

      children.forEach((item, index) => {
        if (item.classList.contains("active")) {
          mobileContainer.style.height = `${item.clientHeight}px`;
        }
      });

      const prevButton = document.querySelector(".msclaire-prev-button");

      if (prevButton) {
        prevButton.addEventListener("click", function (e) {
          e.stopPropagation();
          swipe.onSwipePrev();
        });
      }

      const nextButton = document.querySelector(".msclaire-next-button");

      if (nextButton) {
        nextButton.addEventListener("click", swipe.onSwipeNext);
      }
    }, 1000);
  }

  function updateSearchParams(variantId, color) {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.has("variantId")) {
      urlSearchParams.set("variantId", variantId);
    }

    if (urlSearchParams.has("color")) {
      urlSearchParams.set("color", color.toLowerCase().replace(" ", "-"));
    }

    const url = new URL(window.location);

    url.search = urlSearchParams;

    history.pushState({}, null, url.toString());
  }

  function getSelectedVariantId() {
    const selectElement = document.querySelector("select.t4s-product__select.t4s-d-none");

    return selectElement.value;
  }

  function colorSwatchSelector(selector) {
    const selectedColorElement = document.querySelector(selector);

    const filteredImages = [];
    if (selectedColorElement) {
      const selectedColor = selectedColorElement.dataset["value"]
        .toLowerCase()
        .replace(" ", "-");

      if (selectedColor) {
        updateImageList(selectedColor);
      }
    }
  }

  swipe = new MisclaireSwipe({ root: "#misclaire-product-images-mobile" });


  colorSwatchSelector('div[data-opname="color"] div.is--selected');
  const colorList = document.querySelectorAll('div[data-opname="color"] div');

  if (colorList) {
    for (let index = 0; index < colorList.length; index++) {
      const element = colorList[index];

      element.addEventListener("click", function (e) {
        self = this;

        const selectedColor = self.dataset["value"]
          .toLowerCase()
          .replace(" ", "-");

        if (selectedColor) {
          updateSearchParams(getSelectedVariantId(), selectedColor);
          updateImageList(selectedColor);
        }
      });
    }
  }

  selectColorVariant();
  selectVariantID();
});
